import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Tabs } from 'antd';
import { TabsPane } from './styles';
import TabContent from './TabContent';
import HoverText from '../../CommonComponents/Info/Tooltip/HeaderTooltip'
const { TabPane } = Tabs;


export const TabHead = (props) => { 
  return (
    <HoverText
      mobile={window.screen.availWidth <= 991 ? true : false}
      mobilePlacement='bottomLeft'        
      overlayClassName='disabled-header' 
      placement="top" 
      title={props.text}>
        {props.title}
    </HoverText>
  );
}

TabHead.propTypes = {
  text: PropTypes.any,
  title: PropTypes.any
}

export default function TabsComponent(props) {
  let tabActiveKey = props && props.hasOwnProperty('activeKey') ? props.activeKey.toString(): "1";
  const [active, setActive] = useState(tabActiveKey);
  const [activeKey, setActiveKey] = useState(tabActiveKey);

  const nextClick = () => {
    if (active < tabPanes.length) {
      let nextTab = parseInt(active) + 1;
      setActive(nextTab.toString());
    }
  };

  const prevClick = () => {
    let nextTab = parseInt(active - 1);
    if (active > 0) {
      setActive(nextTab.toString());
    }
  };

  const handleChange = activeKey => {
    setActiveKey(activeKey);
    props.getChange && props.getChange(activeKey);
  };

  const { tabPanes, tabConfig, styling, containerHeight, enableScroll, tooltip, marginRight} = props;

  return (
    <TabsPane
      type='card'
      onPrevClick={prevClick}
      onNextClick={nextClick}
      defaultActiveKey={activeKey}
      onChange={handleChange}
      className={`primary ${styling} `}
    >
      {tabPanes &&
        tabPanes.map((item, tabIndex) => (
          
          <TabPane
            style={{ color: '#022737' }}
            tab={  tooltip && item.tooltipText ? <TabHead text={item.tooltipText} title={item.title} />: item.title}
            key={`${item.key}`}
          >
            <TabContent
              marginRight={marginRight}
              findExpanded={props.findExpanded}
              getPageTitle={props.getPageTitle ? props.getPageTitle: null}
              exportDataUpdate={props.exportDataUpdate ? props.exportDataUpdate: null}
              location={props.location}
              key={tabIndex}
              item={item}
              tabIndex={tabIndex}
              tabConfig={tabConfig}
              containerHeight={containerHeight}
              enableScroll={enableScroll}
              activeKey={activeKey}
              noBorder={props.noBorder}
              yscrollC={props.yscrollC}
              xscroll={props.xscroll}
              accountType={props.accountType}
              dashboard={props.dashboard}
              scrolled={(e, title) => props.scrolled(e, title)}
            />
          </TabPane>
        ))}
    </TabsPane>
  );
}

TabsComponent.propTypes = {
  accountType: PropTypes.any,
  activeKey:PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  containerHeight: PropTypes.string,
  dashboard: PropTypes.any,
  enableScroll: PropTypes.any,
  findExpanded: PropTypes.any,
  getChange: PropTypes.func,
  getPageTitle: PropTypes.any,
  hasOwnProperty: PropTypes.func,
  location: PropTypes.any,
  marginRight: PropTypes.any,
  noBorder: PropTypes.any,
  scrolled: PropTypes.func,
  styling: PropTypes.any,
  tabConfig: PropTypes.func,
  tabPanes: PropTypes.arrayOf(PropTypes.object),
  tooltip: PropTypes.any,
  xscroll: PropTypes.any,
  yscrollC: PropTypes.any
}
